var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-navbar', {
    staticClass: "funko-nav py-md-4",
    attrs: {
      "toggleable": "lg"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/funkomania1.png"),
      "width": "50",
      "alt": "FUNKO POP MANIA"
    }
  })]), _c('b-navbar-toggle', {
    staticClass: "funko-toggle-btn",
    attrs: {
      "target": "nav-collapse"
    }
  }), _c('b-collapse', {
    attrs: {
      "id": "nav-collapse",
      "is-nav": ""
    }
  }, [_c('NavbarItems', {
    attrs: {
      "items": _vm.items,
      "userLogin": _vm.userLogin
    }
  }), _c('NavbarLogin', {
    attrs: {
      "userLogin": _vm.userLogin
    }
  })], 1)], 1), _c('WhatsAppIcon')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }